const showInteraction = require('../interactions/show');
const forms = require('../components/forms');
const getAnalyticsEventCenter = require('../common/getAnalyticsEventCenter');

const analyticsEventCenter = getAnalyticsEventCenter();

const errorElementSelector = '.checkout-error';

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
  forms.clearFormErrors($(parentSelector));
  $('.error-message').hide();
}

function addCheckoutError(message) {
  const errorElement = document.querySelector(errorElementSelector);
  errorElement.textContent = message || errorElement.dataset.technicalError;
  showInteraction.show(errorElement);

  const checkoutStage = require('./checkoutStage');
  const currentStage = checkoutStage.methods.getStage();
  let formName;
  if (currentStage === checkoutStage.stages.PAYMENT_DETAILS) {
    const $fieldControl = $(errorElement);
    const getFormName = $fieldControl.siblings('div').find('form').get(1);
    formName = getFormName?.name;
  } else if (currentStage === checkoutStage.stages.PLACE_ORDER) {
    formName = 'purchase-error';
  }

  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.formErrorShown, {
      errorMessage: message,
      formName,
      pageType: gaInfo.pageType,
    },
  );

  const { checkStageAndScroll } = require('./checkoutCommon').methods;
  checkStageAndScroll();
}

function removeCheckoutError() {
  const errorElement = document.querySelector(errorElementSelector);
  errorElement.textContent = '';
  showInteraction.hide(errorElement);

  const { checkStageAndScroll } = require('./checkoutCommon').methods;
  checkStageAndScroll();
}

module.exports = {
  clearPreviousErrors,
  addCheckoutError,
  removeCheckoutError,
};
